import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import ButtonComponent from '#app/Component/ButtonComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { Product } from '#app/View/ClientService/OrderClientLitige';
import CloseModal from '#app/View/ClientService/OrderClientLitige/CloseModal';
import RefundAmountModal from '#app/View/ClientService/OrderClientLitige/RefundAmountModal';
import RefundModal from '#app/View/ClientService/OrderClientLitige/RefundModal';
import RefundShippingModal from '#app/View/ClientService/OrderClientLitige/RefundShippingModal';
import ReshipmentModal from '#app/View/ClientService/OrderClientLitige/ReshipmentModal';
import { DisputeItem, DisputeType } from '#app/typings/orderClientLitige';

type Props = {
  dispute: DisputeItem;
  reload: () => void;
  products: Product[];
};

const Actions: React.FC<Props> = ({ dispute, reload, products }) => {
  const params = useParams<{ uuid: string }>();
  const uuid = params.uuid as string;
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);

  const [openCloseModal, setOpenCloseModal] = useState<boolean>(false);
  const [openRefundModal, setOpenRefundModal] = useState<boolean>(false);
  const [openReshipmentModal, setOpenReshipmentModal] = useState<boolean>(false);
  const [openRefundShippingModal, setOpenRefundShippingModal] = useState<boolean>(false);
  const [openRefundAmountModal, setOpenRefundAmountModal] = useState<boolean>(false);

  const carrierPrice = dispute?.orderClient.orderClientCarrier?.priceTTC ?? 0;

  const canReshipment = !dispute.forwardingAt && dispute.repaidOrForwardingLegit;
  const canRefund = !dispute.refundAskingAt && dispute.repaidOrForwardingLegit;
  const canRefundShipping = !dispute.refundAskingAt && dispute.type === DisputeType.SHIPPING_FEES && carrierPrice > 0;
  const canRefundAmount = !dispute.refundAskingAt && [DisputeType.PROMO_CODE, DisputeType.OTHER].includes(dispute.type);

  const handleArchived = () => {
    setLoading(true);
    ApiHandler.post({ route: 'api_client_service_order_client_litige_archived', params: { uuid } }, () => {
      dispatch(SnackbarOpen({ text: 'Litige archivé avec succès.', variant: 'success' }));
      reload();
      setLoading(false);
    });
  };

  return (
    <>
      <Grid container spacing={2} className={classes.container}>
        <Grid flex={1}>
          <ButtonComponent color="#D32F2F" label="Archiver" onClick={handleArchived} loading={loading} />
        </Grid>
        <ButtonComponent color="#388E3C" label="Clôturer" onClick={() => setOpenCloseModal(true)} />
        {canReshipment && (
          <ButtonComponent color="#1976D2" label="Réexpédition" onClick={() => setOpenReshipmentModal(true)} />
        )}
        {canRefund && (
          <ButtonComponent color="#E37400" label="Remboursement" onClick={() => setOpenRefundModal(true)} />
        )}
        {canRefundShipping && (
          <ButtonComponent color="#E37400" label="Remboursement" onClick={() => setOpenRefundShippingModal(true)} />
        )}
        {canRefundAmount && (
          <ButtonComponent color="#E37400" label="Remboursement" onClick={() => setOpenRefundAmountModal(true)} />
        )}
      </Grid>
      {openCloseModal && <CloseModal reload={reload} onClose={() => setOpenCloseModal(false)} />}
      {openRefundModal && (
        <RefundModal
          reload={reload}
          products={products}
          onClose={() => setOpenRefundModal(false)}
          carrierPrice={carrierPrice}
          canRefundCarrier={!!dispute?.orderClient.canRefundCarrier}
          canRefundPayment={!!dispute?.orderClient.canRefundPayment}
        />
      )}
      {openRefundShippingModal && (
        <RefundShippingModal
          reload={reload}
          onClose={() => setOpenRefundShippingModal(false)}
          carrierPrice={carrierPrice}
        />
      )}
      {openRefundAmountModal && (
        <RefundAmountModal
          reload={reload}
          onClose={() => setOpenRefundAmountModal(false)}
          countryCode={dispute.orderClient.orderClientAddressBilling?.countryCode}
        />
      )}
      {openReshipmentModal && (
        <ReshipmentModal
          reload={reload}
          products={products}
          onClose={() => setOpenReshipmentModal(false)}
          currentCarrier={dispute?.orderClient.orderClientCarrier?.carrier}
          addressBilling={dispute?.orderClient.orderClientAddressBilling}
          addressShipping={dispute?.orderClient.orderClientAddressShipping}
        />
      )}
    </>
  );
};

const useStyles = makeStyles({
  container: {
    marginTop: 20,
  },
});

export default Actions;
